<template>
    <div class="sticky">
        <img class="Internet" src="@/assets/navbar/back_white.png" alt="" @click="handleBlack"> 

        <img class="Internet" src="@/assets/navbar/Internet_white.png" alt="">
    </div>
</template>
<script>
    export default {
        name:'setPass',
        methods:{
            handleBlack(){
                this.$router.push('/login')
            }
        }
    }
</script>
<style lang="scss" scoped>
     .sticky{
        width: 100%;
        height: 2.75rem;
        position: -webkit-sticky; /* Safari 兼容 */
        position: sticky;
        top: 0;
        background: #1A3232;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;
        box-sizing: border-box;
        .Internet{
            width: 1.5rem;
            height: 1.5rem;
            display: block;
        }
    }
</style>